import { Navigate } from "react-router-dom";
import PATHS from "routes/paths";
import usePermission from "./usePermission";

interface RequirePermissionProps {
    permission: string;
    children: React.ReactElement;
}

const RequirePermission = ({ permission, children }: RequirePermissionProps) => {
    const allowed = usePermission(permission);

    return allowed ? children : <Navigate to={PATHS.FORBIDDEN} replace />;
};

export default RequirePermission;
